import script from "./MobileDrawsSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./MobileDrawsSection.vue?vue&type=script&setup=true&lang=ts"

import "./MobileDrawsSection.vue?vue&type=style&index=0&id=63fc48b3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63fc48b3"]])

export default __exports__